import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { PostPreview } from 'src/app/pages/starterDashboardV2/shared/components';
import type { FullPostType, PostPreviewSizes } from 'src/app/pages/starterDashboardV2/shared/components';

type Props = {
	fullPostType: FullPostType;
	size: PostPreviewSizes;
	petition: StarterDashboardV2PageData['petition'];
};

export function PostPreviewCardSkeleton(props: Props) {
	const { fullPostType, size, petition } = props;

	return (
		<section
			className="flex gap-3"
			data-testid={`${fullPostType}-post-card-skeleton`}
			aria-label={`${fullPostType} post card skeleton`}
		>
			<PostPreview
				variant={fullPostType}
				sharingResource={{
					message: '',
					previewImageUrl: '',
					petitionTitle: '',
					shareUrl: '',
					recommendedGroup: { name: '', url: '', metadata: { memberCount: 0, imageUrl: '', source: '' } },
				}}
				size={size}
				loading
				showPlatformIcon
				petition={petition}
				disabled={false}
			/>
		</section>
	);
}
